module.exports = __webpack_public_path__ + "static/media/Australia.af228565.png";